import React from 'react';
import { $image_url, routes } from 'js/utils';

export default function AnswersLogoAnchor() {
  if (
    !window.location.pathname.toLowerCase().startsWith(routes.answers_path())
  ) {
    return null;
  }

  return (
    <a
      aria-label="answers"
      href={routes.answers_url({ from_navbar: true, trigger: 'nav-logo' })}
      style={{
        display: 'block',
        height: '24px',
        width: 'fit-content',
      }}
    >
      <img
        src={$image_url('/images/answers/answers-logo.min.svg')}
        style={{ height: '23px' }}
      />
    </a>
  );
}
